import * as actionTypes from './actionTypes'
import * as API from '../../api/Admin/Users'

export const adminAllUsersListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.USERS_LIST_REQUEST, payload: data})
        return API.allUsersListApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.USERS_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.USERS_LIST_ERROR, payload:error})    
            })
    }
}
export const adminUsersStatusAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.USERS_STATUS_CHANGE_REQUEST, payload: data})
        return API.achangeUserStatusApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.USERS_STATUS_CHANGE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.USERS_STATUS_CHANGE_ERROR, payload:error})    
            })
    }
}

export const adminUsersResumeAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.RESUME_ACTIVITY_LIST_REQUEST, payload: data})
        return API.resumeSendListApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.RESUME_ACTIVITY_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.RESUME_ACTIVITY_LIST_ERROR, payload:error})    
            })
    }
}



// WEBPACK FOOTER //
// ./src/actions/Admin/Users.js